import {
  Groth16Config,
  Plonky2Config,
  ProofOptions,
  Risc0Config,
  TeeConfig,
  UltraplonkConfig,
  UltrahonkConfig,
} from '../config/index.js';

import { BatchOptimisticVerificationBuilder } from './builders/batchOptimisticVerify/index.js';
import { BatchVerificationBuilder } from './builders/batchVerify/index.js';
import { NetworkConfig } from '../types.js';
import { OptimisticVerificationBuilder } from './builders/optimisticVerify/index.js';
import { RegisterKeyBuilder } from './builders/register/index.js';
import { VerificationBuilder } from './builders/verify/index.js';

export interface zkVerifySessionOptions {
  networkConfig: NetworkConfig;
  seedPhrases?: string[];
  wallet?: WalletOptions;
}

export interface WalletOptions {
  source: string;
  accountAddress: string;
}

export interface VerifyOptions {
  proofOptions: ProofOptions;
  accountAddress?: string;
  nonce?: number;
  registeredVk?: boolean;
  domainId?: number;
}

export interface OptimisticVerifyOptions extends VerifyOptions {
  block?: number | string;
}

type GenericProofMethodMap<TBuilder> = {
  ezkl: () => TBuilder;
  fflonk: () => TBuilder;
  groth16: (options: Groth16Config) => TBuilder;
  plonky2: (options: Plonky2Config) => TBuilder;
  risc0: (options: Risc0Config) => TBuilder;
  sp1: () => TBuilder;
  ultrahonk: (options?: UltrahonkConfig | null) => TBuilder;
  ultraplonk: (options: UltraplonkConfig) => TBuilder;
  tee: (options?: TeeConfig | null) => TBuilder;
  // ADD_NEW_PROOF_TYPE
};

export type ProofMethodMap = GenericProofMethodMap<VerificationBuilder>;
export type OptimisticProofMethodMap =
  GenericProofMethodMap<OptimisticVerificationBuilder>;
export type BatchProofMethodMap =
  GenericProofMethodMap<BatchVerificationBuilder>;
export type BatchOptimisticProofMethodMap =
  GenericProofMethodMap<BatchOptimisticVerificationBuilder>;
export type RegisterKeyMethodMap = GenericProofMethodMap<RegisterKeyBuilder>;
